/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Deep_P1Inputs */

const en_sorter_deep_p1 = /** @type {(inputs: Sorter_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keys are compared with the browser locale collation rather than by character code, and the two disagree more often than you would expect. Locale collation treats letters as primary and case as a tiebreaker, so alpha sorts before Beta. Byte order compares code points, where every uppercase ASCII letter comes before every lowercase one, so Beta would sort before alpha. Feed in Beta, alpha, and Alpha and this tool returns alpha, Alpha, Beta.`)
};

const ko_sorter_deep_p1 = /** @type {(inputs: Sorter_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키는 문자 코드가 아니라 브라우저 로케일의 정렬 규칙으로 비교되며, 둘은 예상보다 자주 어긋납니다. 로케일 정렬은 글자를 우선으로 보고 대소문자를 동점 처리 기준으로 쓰므로 alpha가 Beta보다 앞섭니다. 바이트 순은 코드 포인트를 비교하는데, ASCII 대문자는 모두 소문자보다 앞이므로 Beta가 alpha보다 앞이 됩니다. Beta, alpha, Alpha를 넣으면 이 도구는 alpha, Alpha, Beta를 반환합니다.`)
};

const ja_sorter_deep_p1 = /** @type {(inputs: Sorter_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーは文字コードではなくブラウザのロケール照合順序で比較され、両者は思った以上に頻繁に食い違います。ロケール照合は文字を第一に見て大文字小文字を同点処理の基準とするため、alpha が Beta より前に来ます。バイト順はコードポイントを比較し、ASCII の大文字はすべて小文字より前なので Beta が alpha より前になります。Beta, alpha, Alpha を入れると、このツールは alpha, Alpha, Beta を返します。`)
};

/**
* | output |
* | --- |
* | "Keys are compared with the browser locale collation rather than by character code, and the two disagree more often than you would expect. Locale collation tr..." |
*
* @param {Sorter_Deep_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_deep_p1 = /** @type {((inputs?: Sorter_Deep_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Deep_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_deep_p1(inputs)
	if (locale === "ko") return ko_sorter_deep_p1(inputs)
	return ja_sorter_deep_p1(inputs)
});